import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import AppLayout from "@/components/AppLayout";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ClientExport from "@/pages/ClientExport";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientProfile from "@/pages/ClientProfile";
import Projects from "@/pages/Projects";
import Tasks from "@/pages/Tasks";
import Deliverables from "@/pages/Deliverables";
import CalendarPage from "@/pages/Calendar";
import Finance from "@/pages/Finance";
import Quotations from "@/pages/Quotations";
import QuotationPrint from "@/pages/QuotationPrint";
import Team from "@/pages/Team";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";

import "@/App.css";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/quotations/:id/print" element={<QuotationPrint />} />
              <Route path="/clients/:id/export" element={<ClientExport />} />
              <Route element={<AppLayout />}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/clients/:id" element={<ClientProfile />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/tasks" element={<Tasks />} />
                <Route path="/deliverables" element={<Deliverables />} />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/finance" element={<Finance />} />
                <Route path="/quotations" element={<Quotations />} />
                <Route path="/team" element={<Team />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/audit-log" element={<AuditLog />} />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
